import { HelpPreference } from '@/autogenerated/@prisma/prisma-mongo-client';
import { IconName } from '@/components/ui/Icon';
export const helpPreferences = [
  {
    value: HelpPreference.language,
    color: 'secondary',
    lightColor: 'secondary-200',
    iconVariant: IconName.Language,
  },
  {
    value: HelpPreference.network,
    color: 'tertiary',
    lightColor: 'tertiary-200',
    iconVariant: IconName.Network,
  },
  {
    value: HelpPreference.community,
    color: 'primary',
    lightColor: 'primary-100',
    iconVariant: IconName.Community,
  },
] as const;
